import type {MobileAuthedWebviewEntryPointConfig} from '../ConnectElementList';

export const selectedCurrencyParameter = 'selected-currency';

export const AddFundsConfig: MobileAuthedWebviewEntryPointConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "PayoutsEntryPointAddFunds" */
      '../../../components/Payouts/Balance/BalanceBody/BalanceDetailsModal/AddFundsEntryPoint'
    ),
  description: 'Mobile authed webview entry point to add funds',
  friendlyName: 'Mobile entry point: add funds',
  htmlAttributes: {
    [selectedCurrencyParameter]: {
      isInternal: true,
    },
  },
  customHtmlElementMethods: {
    setSelectedCurrency: {
      type: 'AttributeSettingMethod',
      attribute: selectedCurrencyParameter,
      isInternal: true,
      description: 'Set the selected currency',
    },
  },
};
